import { DiscoveryApi, IdentityApi } from '@backstage/core-plugin-api';
import { SecDashApi } from './SecDashApi';

export type Options = {
  discoveryApi: DiscoveryApi;
  identityApi: IdentityApi;
};

type Props = {
  parameters: {
    project: string | undefined;
    group: string | undefined;
    scanner: string | undefined;
    severity: string | undefined;
    timeframe: string | undefined;
    app: string | undefined;
  };
};

export class SecDashApiClient implements SecDashApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly identityApi: IdentityApi;

  constructor(options: Options) {
    this.discoveryApi = options.discoveryApi;
    this.identityApi = options.identityApi;
  }

  async get(path: string): Promise<any> {
    const url = `${await this.discoveryApi.getBaseUrl('secdash')}${path}`;
    const { token: idToken } = await this.identityApi.getCredentials();
    const response = await fetch(url, {
      headers: idToken ? { Authorization: `Bearer ${idToken}` } : {},
    });

    if (!response.ok) {
      const payload = await response.text();
      const message = `Request failed with ${response.status} ${response.statusText}, ${payload}`;
      throw new Error(message);
    }

    return await response.json();
  }

  async getData({
    parameters: { project, group, scanner, severity, timeframe, app },
  }: Props): Promise<any> {
    return this.get(
      `/data?project=${project}&group=${group}&scanner=${scanner}&severity=${severity}&timeframe=${timeframe}&app=${app}`,
    );
  }

  async getScannerExplanations(scanner: string | undefined): Promise<any> {
    return this.get(`/scannerexplanation?scanner=${scanner}`);
  }

  async getAccordionProjects(group: string): Promise<any> {
    return this.get(`/accordionprojects?group=${group}`);
  }
}
